import styled from '@benzinga/themetron';
import React from 'react';
import { SearchTool } from '../SearchBar';
import { faWrench } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '@benzinga/core-ui';

export const ENABLE_BUILDER_ID = 'enable_builder' as const;

export interface EnableBuilder extends SearchTool {
  id: typeof ENABLE_BUILDER_ID;
}

export const createEnableBuilder = (enableBuilder: () => void): EnableBuilder => {
  return {
    getTool: (_, _1, _2) => {
      return <StyledIcon icon={faWrench} key="enable-builder-icon" onClick={enableBuilder} />;
    },
    id: ENABLE_BUILDER_ID,
  };
};

export function isEnableBuilder(tool: SearchTool): tool is EnableBuilder {
  return tool.id === ENABLE_BUILDER_ID;
}

export const useEnableBuilder = (enableBuilder: () => void): EnableBuilder => {
  return React.useMemo(() => createEnableBuilder(enableBuilder), [enableBuilder]);
};

const StyledIcon = styled(Icon)`
  fill: ${props => props.theme.colors.brand};
  font-size: 12px;
  cursor: pointer;
  margin: 8px;
`;
